module.exports = __webpack_public_path__ + "static/media/perfect-gold_00010.503ebfe2.png";